import { useId, type FC } from "react";
import type { InputProps, Option } from "~/utils/types";
import { ComboBox } from "../combobox";
import { FormDescription, FormField, FormItem, FormLabel, FormMessage } from "../ui/form";

const ComboBoxFormInput: FC<
  InputProps & {
    multiple?: boolean;
    allowClear?: boolean;
    renderOption?: (option: Option) => React.ReactNode;
    rowHeight?: number;
    resultsWindowSize?: number;
    filterOnOriginal?: string[];
    tabIndex?: number;
  }
> = ({
  name,
  label,
  helperText,
  options,
  multiple,
  allowClear,
  renderOption,
  rowHeight,
  resultsWindowSize,
  filterOnOriginal,
  tabIndex,
  required,
}) => {
  const id = useId();
  return (
    <FormField
      name={name}
      render={({ field }) => {
        return (
          <FormItem>
            <FormLabel required={required} name={name} htmlFor={id}>
              {label}
            </FormLabel>
            <ComboBox
              id={id}
              tabIndex={tabIndex}
              renderOption={renderOption}
              multiple={multiple}
              allowClear={allowClear}
              filterOnOriginal={filterOnOriginal}
              value={field.value}
              onChange={(val) => field.onChange({ target: { value: val } })}
              options={options || []}
              rowHeight={rowHeight}
              resultsWindowSize={resultsWindowSize}
            />
            {helperText && <FormDescription>{helperText}</FormDescription>}
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};

export { ComboBoxFormInput };
